import { schedulingNavigationItems, schedulingRoutes } from "./router";
export class SchedulingModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[SchedulingModule] Registered");
        return { id: "scheduling", name: "Scheduling Module", version: "1.0.0" };
    }
    getRoutes() {
        return schedulingRoutes;
    }
    getNavigationItems() {
        return schedulingNavigationItems;
    }
    getComponent(_slotName) {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[SchedulingModule] Unregistered");
        this.contracts = null;
    }
}
export default new SchedulingModule();
